<script setup></script>

<template>
  <VBusHelper :emitOnMounted="$constants.EVENTS.COUPONS.LIST_ALL.REFRESH" />
  <CouponsLoadingError
    v-if="$stores.coupons?.state?.list_all?.error"
    @refresh="() => $bus.emit($constants.EVENTS.COUPONS.LIST_ALL.REFRESH)"
  >
    <template #errorDescription>
      {{ $stores.coupons?.state?.list_all?.error }}
    </template>
  </CouponsLoadingError>
  <div
    v-else-if="$stores.coupons?.state?.list_all?.list.length"
    class="flex flex-col gap-8 pt-3 pb-12 overflow-x-hidden h-full"
  >
    <div
      class="addBox relative [&_*]:dduration-[0] **:delay-100d"
      v-for="(pub, i) in $stores.coupons?.state?.list_all?.list"
      :class="{
        'h-[450px]': !pub.isSmall,
        'h-[150px]': pub.isSmall
      }"
      :key="i"
    >
      <div class="mainBox h-full px-8 flex justify-between flex-col opacity-90">
        <div class="px-8 absolute w-full h-full left-0 top-0">
          <div
            class="w-full h-full opacity-30 rounded-3xl"
            style="
              background: linear-gradient(
                to bottom right,
                var(--color-primary),
                var(--color-secondary)
              );
            "
          ></div>
        </div>
        <div
          class="w-full h-full rounded-3xl overflow-hidden shadow-2xl relative z-1"
        >
          <img
            :src="pub.pictureUrl"
            alt=""
            :class="{
              'h-[350px]': !pub.isSmall,
              'h-[150px]': pub.isSmall
            }"
            class="w-full object-cover scale-[1.1]"
          />
          <div class="absolute bottom-0 textContent z-2 p-4">
            <div class="text-4xl text-white font-bold">
              {{ pub.title }}
            </div>
            <div class="text-white font-bold">
              {{ pub.description }}
            </div>
          </div>
          <div
            class="absolute bottom-0 h-[200px] w-full left-0 bluredContent"
            style="
              mask-image: linear-gradient(
                to top,
                white,
                white 50%,
                transparent
              );
            "
            :class="{
              'translate-y-1/2': pub.isSmall
            }"
          >
            <img
              :src="pub.pictureUrl"
              alt=""
              class="w-full h-full object-cover"
            />
            <div
              class="absolute top-0 left-0 w-full h-full bg-primary-500 bg-opacity-90"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    v-else-if="$stores.coupons?.state?.list_all?.loading"
    class="flex flex-col gap-8 pt-3 pb-12 overflow-x-hidden h-full shimmerContainer"
  >
    <div
      class="addBox relative [&_*]:dduration-[0] **:delay-100d h-[450px]"
      v-for="i in 3"
      :key="i"
    >
      <div class="mainBox h-full px-8 flex justify-between flex-col opacity-90">
        <div class="px-8 absolute w-full h-full scale-[1.01] left-0 top-0">
          <div class="w-full h-full opacity-30 rounded-3xl shimmerTarget"></div>
        </div>
        <div
          class="w-full h-full rounded-3xl overflow-hidden shadow-2xl relative z-1 shimmerTarget"
        ></div>
      </div>
    </div>
  </div>
  <EmptyCoupons
    v-else
    @refresh="() => $bus.emit($constants.EVENTS.COUPONS.LIST_ALL.REFRESH)"
  />
</template>
